import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

export const Container = styled.div`
  width: 100%;
  max-width: 50rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1.5rem;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
`;

export const IconWrapper = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: linear-gradient(135deg, ${Theme.colors.B_3} 0%, ${Theme.colors.B_4} 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
  box-shadow: 0 2px 8px rgba(19, 127, 218, 0.2);
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

interface RadioOptionProps {
  selected: boolean;
}

export const RadioOption = styled.div<RadioOptionProps>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  border: 2px solid
    ${({ selected }) => (selected ? Theme.colors.B_3 : Theme.colors.G_4)};
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
  background-color: ${({ selected }) =>
    selected ? Theme.colors.G_6 : Theme.colors.WHITE};

  &:hover {
    border-color: ${Theme.colors.B_3};
  }
`;

export const RadioInput = styled.input`
  width: 1.25rem;
  height: 1.25rem;
  accent-color: ${Theme.colors.B_3};
  cursor: pointer;
`;

export const PostpaidNotice = styled.div`
  padding: 1rem;
  background-color: ${Theme.colors.G_6};
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const PrepaidPostpaidNotice = styled.div`
  padding: 1rem;
  background-color: ${Theme.colors.G_6};
  border: 1px solid ${Theme.colors.G_4};
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.75rem;
`;

export const BillingSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background-color: ${Theme.colors.G_6};
  border-radius: 0.5rem;
`;

export const TotalPrice = styled.div`
  margin-bottom: 1rem;
`;

export const PriceBreakdown = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid ${Theme.colors.G_4};
`;

export const BreakdownLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BreakdownLineWithSpacing = styled(BreakdownLine)`
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid ${Theme.colors.G_4};
`;

